import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { GSAPModule } from '@df/ui/display/gsap/gsap.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { LocalVimeoPlayerComponent } from '../../../../../ui/display/media/vimeo-player.component';
import config from './full-width-banner.config';
import { PageComponentFullWidthBannerComponentData } from './full-width-banner.interface';

@Component({
    selector: 'page-component-full-width-banner',
    templateUrl: './full-width-banner.html',
    styleUrl: './full-width-banner.scss',
    standalone: true,
    imports: [
        DfImageDirective,
        GSAPModule,
        HrefComponent,
        ICmsClientModule,
        LocalVimeoPlayerComponent,
        NgTemplateOutlet,
        RouterModule,
        ShellComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentFullWidthBannerComponent>(config)
export class PageComponentFullWidthBannerComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: PageComponentFullWidthBannerComponentData;
}
